// Metadata shared by routing, prerendering and SEO; article bodies stay in lazy page modules.
export const halsArticle = {
  path: '/lewy-prawy-hals-pierwszenstwo/',
  title: 'Lewy i prawy hals - jak je rozpoznać i co oznaczają dla pierwszeństwa?',
  seoTitle: 'Lewy i prawy hals — pierwszeństwo jachtów — Przed rejsem',
  description: 'Jak rozpoznać lewy i prawy hals? Poznaj zasady ustępowania drogi między jachtami, zobacz diagramy i sprawdź wiedzę w ćwiczeniu z odpowiedzią.',
  date: '2026-10-18',
  dateLabel: '18 października 2026',
  image: '/articles/halsy/rozne-halsy.svg',
};

export const motorboatExamArticle = {
  path: '/egzamin-sternik-motorowodny/',
  title: 'Egzamin na sternika motorowodnego - jak wygląda teoria i praktyka?',
  seoTitle: 'Egzamin na sternika motorowodnego — poradnik — Przed rejsem',
  description: 'Jak wygląda egzamin na patent sternika motorowodnego? Poznaj test teoretyczny, przebieg praktyki i manewry. Przeczytaj poradnik i przejdź do darmowego testu próbnego.',
  date: '2026-10-20',
  dateLabel: '20 października 2026',
};
